// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Items_pageLayout__1Peio"};